
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import ScrollReveal from "@/components/ui/scroll-reveal";
import { useTranslation } from "@/hooks/useTranslation";
import { 
  Database, 
  ShieldCheck, 
  FileCheck, 
  FileHeart, 
  ShieldAlert, 
  CheckCheck, 
  UserCheck, 
  Shield
} from "lucide-react";

const CustomerExperienceOwnership = () => {
  const { t } = useTranslation();

  const securityFeatures = [
    {
      titleKey: "customerExperience.features.fullyOwnedData.title",
      descriptionKey: "customerExperience.features.fullyOwnedData.description",
      color: "bg-brand-500",
      icon: <Database className="w-6 h-6 text-brand-500" />
    },
    {
      titleKey: "customerExperience.features.soc2Certified.title",
      descriptionKey: "customerExperience.features.soc2Certified.description",
      color: "bg-brand-600",
      icon: <ShieldCheck className="w-6 h-6 text-brand-600" />
    },
    {
      titleKey: "customerExperience.features.gdprCompliant.title",
      descriptionKey: "customerExperience.features.gdprCompliant.description",
      color: "bg-brand-400",
      icon: <FileCheck className="w-6 h-6 text-brand-400" />
    },
    {
      titleKey: "customerExperience.features.hipaaReady.title",
      descriptionKey: "customerExperience.features.hipaaReady.description",
      color: "bg-brand-700",
      icon: <FileHeart className="w-6 h-6 text-brand-700" />
    },
    {
      titleKey: "customerExperience.features.penetrationTesting.title",
      descriptionKey: "customerExperience.features.penetrationTesting.description",
      color: "bg-brand-400",
      icon: <ShieldAlert className="w-6 h-6 text-brand-400" />
    },
    {
      titleKey: "customerExperience.features.qualityAssurance.title",
      descriptionKey: "customerExperience.features.qualityAssurance.description",
      color: "bg-brand-700",
      icon: <CheckCheck className="w-6 h-6 text-brand-700" />
    },
    {
      titleKey: "customerExperience.features.whiteGlove.title",
      descriptionKey: "customerExperience.features.whiteGlove.description",
      color: "bg-brand-500",
      icon: <UserCheck className="w-6 h-6 text-brand-500" />
    },
    {
      titleKey: "customerExperience.features.enterpriseGuardrails.title",
      descriptionKey: "customerExperience.features.enterpriseGuardrails.description",
      color: "bg-brand-600",
      icon: <Shield className="w-6 h-6 text-brand-600" />
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4">
        <ScrollReveal>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900 dark:text-white">
              {t("customerExperience.title")}
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300">
              {t("customerExperience.subtitle")}
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {securityFeatures.map((feature, index) => (
            <ScrollReveal key={index} delay={index * 100}>
              <Card className="h-full bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-md hover:shadow-lg transition-all duration-300">
                <CardContent className="p-6 h-full flex flex-col">
                  <div className="mb-6 flex items-center">
                    {feature.icon}
                    <h3 className="ml-3 font-semibold text-gray-900 dark:text-white">{t(feature.titleKey as any)}</h3>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300 text-sm flex-grow">
                    {t(feature.descriptionKey as any)}
                  </p>
                </CardContent>
              </Card>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerExperienceOwnership;
